import { render, staticRenderFns } from "./TableSpiner.vue?vue&type=template&id=1f520ef1&"
import script from "./TableSpiner.vue?vue&type=script&lang=js&"
export * from "./TableSpiner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports